import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { Typography } from "@material-ui/core";
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const iconProps = {style: { fontSize: 50, marginRight: 16 }}

const AlertDialog = ({ close, message, options }) => {

    const Icon = {
        'info': <ErrorIcon {...iconProps} />,
        'success': <CheckCircleIcon {...iconProps} />,
        'error': <ErrorIcon {...iconProps} />
    }
    const closeButtonText = {
        'info': 'Okay',
        'success': 'Okay',
        'error': 'Close'
    }

    return (
        <Dialog
            open={true}
            onClose={close}
            keepMounted
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle id="alert-dialog-slide-title">{options.title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description" style={{ display: 'flex', minWidth: 300, justifyContent: 'center', alignItems: 'center' }}>
                    {!options.hideIcon && Icon[options.type]}
                    <Typography style={{ flex: 1 }}>{message}</Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {options.actions &&
                    options.actions.map((action, index) => (
                        <Button
                            onClick={() => {
                                action.onClick();
                                close();
                            }}
                            color="primary"
                            key={index}
                        >
                            {action.copy}
                        </Button>
                    ))}
                <Button onClick={close} color="primary">
                    {options.closeCopy || closeButtonText[options.type]}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AlertDialog;